// ISO bölge kodu → desteklenen her dilde ülke adı. api/scripts/gen_country_names.mjs
// ile Intl.DisplayNames'ten üretildi (bkz. o script, aynı JSON api/src'de de var).
import COUNTRY_NAMES from './country-names.json';

type CountryEntry = Record<string, string>;

// Üniversite arama sonuçlarındaki `country` (İngilizce serbest metin) yerine,
// `country_code` üzerinden geçerli görüntüleme diline uygun adı döndürür.
// Kod eşleşmezse (backfill'de yakalanmamış nadir bir değer) ya da o dil için
// üretilmiş ad yoksa (desteklenmeyen dil), İngilizce ham metne düşer.
export function localizedCountry(countryCode: string | null | undefined, fallback: string, lang: string): string {
  if (!countryCode) return fallback;
  const entry = (COUNTRY_NAMES as Record<string, CountryEntry>)[countryCode];
  if (!entry) return fallback;
  return entry[lang] ?? entry.en ?? fallback;
}
